import BreadCrumb, {
  BreadCrumbOption
} from '@service-victoria/component-library/components/BreadCrumb';
import Footer from '@service-victoria/component-library/components/Footer';
import Header from '@service-victoria/component-library/components/Header';
import React from 'react';

import Banner from '../Banner';
import {
  ContentContainer,
  ContentFooterContainer,
  ContentFooterLogo,
  ContentFooterServiceVictoriaText,
  ContentFooterText,
  ContentFooterTextContainer,
  ContentWrapper
} from './styled';

interface PageProps {
  banner?: {
    title: string;
    content?: React.ReactNode;
    size?: 'small';
  };
  showHeader?: boolean;
  breadCrumbOptions?: BreadCrumbOption[];
  contentSize?: 'small' | 'large' | 'default';
  showContentFooter?: boolean;
  showPageFooter?: boolean;
  noContentPadding?: boolean;
}

export const Page: React.FC<PageProps> = ({
  banner,
  children,
  showHeader,
  breadCrumbOptions,
  contentSize = 'small',
  showContentFooter = true,
  showPageFooter = false,
  noContentPadding = false
}) => (
  <>
    {showHeader && <Header fetchItemsFromAPI showSideNav={true} />}
    {breadCrumbOptions?.length && (
      <nav>
        <BreadCrumb items={breadCrumbOptions ?? []} />
      </nav>
    )}
    {banner && <Banner title={banner.title} size={banner.size} />}
    <ContentWrapper size={contentSize} hasBanner={!!banner}>
      {banner && banner.content}
      <ContentContainer data-testid='PageContainer' noContentPadding={noContentPadding}>
        {children}
      </ContentContainer>
      {showContentFooter && (
        <ContentFooterContainer
          as={showPageFooter ? 'div' : 'footer'}
          data-testid='FooterContainer'>
          <ContentFooterLogo withoutStateGovernmentText={true} />
          <ContentFooterTextContainer data-testid='FooterText'>
            <ContentFooterText>Powered by</ContentFooterText>
            <ContentFooterServiceVictoriaText>Service Victoria</ContentFooterServiceVictoriaText>
          </ContentFooterTextContainer>
        </ContentFooterContainer>
      )}
    </ContentWrapper>
    <Footer showFooter={showPageFooter} />
  </>
);

export default Page;
